<div id="dialog">
  <div class="modal-content csc-modal">
    <div class="modal-body"><span [innerHtml]="data.message | safeHtml">{{data.message}}</span>
      <span *ngIf="data.time"> {{data.time}} seconds</span>
    </div>
    <!--<div class="modal-footer">
      <div class="float-right">
        <button *ngIf="data.time" class="btn btn-csc-primary" [mat-dialog-close]="'stopIdle'">I'm Here</button>
      </div>
      <div class="col-sm-3">
        <button *ngIf="!data.time" class="btn btn-csc-primary" [mat-dialog-close]="true" (click)="onClick()">Ok</button>
      </div>
      <div class="col-sm-3">
        <button class="btn btn-outline-secondary" *ngIf="data.cancelButton" [mat-dialog-close]="false">Cancel</button>
      </div>
    </div>-->
    <div class="modal-footer">
      <button *ngIf="!data.time" class="btn btn-csc-primary" [mat-dialog-close]="true" (click)="onClick()">Ok</button>
      <button class="btn btn-outline-secondary" *ngIf="data.cancelButton" [mat-dialog-close]="false">Cancel</button>
      <button *ngIf="data.time" class="btn btn-csc-primary" [mat-dialog-close]="'stopIdle'">I'm Here</button>
    </div>
  </div>
</div>





